import i18n from '@/i18n'

export default [
  {
    name: 'TaskStatusOptions',
    value: [
      { label: i18n.t('tasks.wait'), value: 'wait' }, // 等待
      { label: i18n.t('tasks.run'), value: 'run', colorClazz: 'text-color-gold' }, // 运行
      { label: i18n.t('common.success'), value: 'success', colorClazz: 'text-color-success' }, // 成功
      { label: i18n.t('common.failure'), value: 'failure', colorClazz: 'text-color-error' } // 失败
    ]
  },
  {
    name: 'MatchMethodOptions',
    value: [
      { label: i18n.t('tasks.exact'), value: 0 }, // 精确
      { label: i18n.t('tasks.fuzzy'), value: 1 } // 模糊
    ]
  },
  {
    name: 'RefreshTypeOptions',
    value: [
      { label: i18n.t('tasks.urlRefresh'), value: '0', key: 'url' }, // URL刷新
      { label: i18n.t('tasks.dirRefresh'), value: '1', key: 'dir' } // 目录刷新
    ]
  },
  {
    name: 'TaskTypeOptions',
    value: [
      { label: i18n.t('tasks.immediate'), value: '0' }, // 即时
      { label: i18n.t('tasks.reservation'), value: '1' }, // 预约
      { label: i18n.t('tasks.cycle'), value: '2' } // 循环
    ]
  },
  {
    name: 'LowercaseOptions',
    value: [
      { label: i18n.t('common.yes'), value: '0' }, // 是
      { label: i18n.t('common.no'), value: '1' } // 否
    ]
  },
  {
    name: 'DelayUnitOptions',
    value: [
      { label: i18n.t('tasks.minute'), value: 1 }, // 分
      { label: i18n.t('tasks.hour'), value: 60 } // 时
    ]
  },
  {
    name: "FrequencyOptions",
    value: [
      { label: i18n.t('common.everyday'), value: 'd' }, // 每天
      { label: i18n.t('common.monday'), value: 'w1' }, // 周一
      { label: i18n.t('common.tuesday'), value: 'w2' }, // 周二
      { label: i18n.t('common.wednesday'), value: 'w3' }, // 周三
      { label: i18n.t('common.thursday'), value: 'w4' }, // 周四
      { label: i18n.t('common.friday'), value: 'w5' }, // 周五
      { label: i18n.t('common.saturday'), value: 'w6' }, // 周六
      { label: i18n.t('common.sunday'), value: 'w7' }, // 周日
    ]
  }
]
